<div class="border-container bg-white mb-3">
  <app-bank-fields [disableMode]="true"></app-bank-fields>
</div>
